import { useState, useEffect } from "react";
import { getMembers, IMember, sendBotBroadcastMessage } from "../../../../services/amityService";
import { fetchNotificationUsers } from "../../../../api/notificationUser";
import { NotificationUser } from "../../../../models/notificationUser";

export const useNotification = () => {
    const [notificationUsers, setNotificationUsers] = useState<NotificationUser[]>([]);
    const [users, setUsers] = useState<IMember[]>([]);
    const [isLastPage, setIsLastPage] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        const fetchData = async () => {
            if (isLastPage) return;
            const data = await fetchNotificationUsers({ page: currentPage, limit: 100 });
            if (data.totalPages === currentPage) {
                setIsLastPage(true);
            }
            setNotificationUsers([...notificationUsers, ...data.users]);
            setCurrentPage(currentPage + 1);
        }

        getMembers((members) => setUsers(members));

        fetchData();
    }, []);

    const getProfileUniqueId = (userId: string): string[] => {
        return users.filter(user => user.rioUserIds.includes(userId))?.map(user => user.profileUniqueId) ?? [];
    }

    const sendBudgetNotification = (data: { createdBy: string, message: string, budgetId: string }) => {
        const redirectUri = import.meta.env.VITE_LOGIN_REDIRECT_URI ?? '';
        const baseUrl = redirectUri.includes('/') 
            ? redirectUri.substring(0, redirectUri.lastIndexOf('/'))
            : redirectUri;

        const consultantId = getProfileUniqueId(data.createdBy)[0];
        const controlTowerIds = notificationUsers.filter(user => user.userId !== data.createdBy).flatMap(user => getProfileUniqueId(user.userId));
        try {
            sendBotBroadcastMessage([
                {
                    message: data.message,
                    targetUserIds: [consultantId],
                    link: `${baseUrl}/dealership/budgets/${data.budgetId}/versions/latest`,
                    linkLabel: 'Visualizar orçamento',
                },
                {
                    message: data.message,
                    targetUserIds: Array.from(new Set(controlTowerIds)),
                    link: `${baseUrl}/control-tower/budgets/${data.budgetId}/versions/latest`,
                    linkLabel: 'Visualizar orçamento',
                }
            ]);
        } catch (error) {
            console.error("Erro ao enviar mensagem:", error);
        }
    }

    return { 
        sendBudgetNotification,
    };
};